<template>
  <div :class="$style.component">
    <div :class="$style.titleContainer">
      <div :class="$style.title">{{ label }}</div>
      <icon
          v-if="showInfo"
          @click.native="infoClicked"
          icon="info-filled"
          :class="$style.info"
      ></icon>
      <span v-if="optional" :class="$style.optional">{{optionalLabel}}</span>
    </div>
    <p :class="$style.description" v-if="hasSlotContent">
      <slot></slot>
    </p>
    <input type="tel"
           :class="[$style.input, { [$style.inputError]: isInvalid }, $style[size]]"
           :disabled="disabled"
           :value="formattedValue"
           @change="inputValueChanged"
           @blur="onInputBlur($event)"
           v-money="{ precision, decimal, thousands, prefix, suffix }"
    />
    <div>
      <slot name="result"></slot>
    </div>
  </div>
</template>

<script>
import { VMoney } from 'v-money'
import icon from "../display/icon";
import { defaults, format, unformat } from "../../utils/money-util";

export default {
  name: "currency-input-fragment",
  directives: { money: VMoney },
  components: { icon },
  props: {
    label: { type: String, required: true },
    showInfo: { type: Boolean, default: false }, // Show info icon
    optional: { type: Boolean, default: false },
    optionalLabel: { type: String, default: "Optioneel" },
    value: { type: [Number, String], default: 0 },
    disabled: { type: Boolean, default: false },
    isInvalid: { type: Boolean, default: false },
    size: {
      type: String,
      default: "medium",
      validator: function(value) {
        return ["small", "medium", "max"].indexOf(value) !== -1;
      }
    },
    masked: { type: Boolean, default: false }, // If output should include the mask or not
    precision: { type: Number, default: () => defaults.precision },
    decimal: { type: String, default: () => defaults.decimal },
    thousands: { type: String, default: () => defaults.thousands },
    prefix: { type: String, default: () => defaults.prefix },
    suffix: { type: String, default: () => defaults.suffix }
  },
  data() {
    return {
      formattedValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        const formatted = format(newValue || 0, this.$props)
        if (formatted !== this.formattedValue) {
          this.formattedValue = formatted
        }
      }
    }
  },
  computed: {
    hasSlotContent() {
      return this.$slots && this.$slots.default && this.$slots.default.length;
    }
  },
  methods: {
    inputValueChanged($event) {
      this.$emit('input', this.masked ? $event.target.value : unformat($event.target.value, this.precision))
    },
    infoClicked() {
      this.$emit("info-clicked");
    },
    onInputBlur($event) {
      this.$emit("blur", unformat($event.target.value));
    }
  }
};
</script>

<style module lang="scss">
@import "../../style/modules/input.module";
</style>
